'use es6';

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import text from 'I18n/utils/unescapedText';
import AutofillHoneypot from '../component/AutofillHoneypot';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';
const ExchangeAccountSettings = ({
  onFieldChange,
  isEmailFieldDisabled,
  isUsernameFieldDisabled,
  isUsernameFieldHidden,
  isPasswordFieldDisabled,
  validationMessages,
  value
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(AutofillHoneypot, {}), /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.emailLabel`
    }),
    required: true,
    error: Boolean(validationMessages.email),
    validationMessage: !!validationMessages.email && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.email
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      autoComplete: `exchangeemail-no-autocomplete-${Math.random()}`,
      name: "email",
      disabled: isEmailFieldDisabled,
      placeholder: text(`${LANG_ROUTE}.emailPlaceholder`),
      defaultValue: value.email,
      onChange: evt => {
        onFieldChange(evt, 'email');
      }
    })
  }), !isUsernameFieldHidden && /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.customUsernameLabel`
    }),
    required: false,
    error: Boolean(validationMessages.customUsername),
    validationMessage: !!validationMessages.customUsername && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.customUsername
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      autoComplete: `exchangeuser-no-autocomplete-${Math.random()}`,
      name: "customUsername",
      disabled: isUsernameFieldDisabled,
      placeholder: text(`${LANG_ROUTE}.exchange.usernamePlaceholder`),
      defaultValue: value.customUsername,
      onChange: evt => onFieldChange(evt, 'customUsername')
    })
  }), /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.passwordLabel`
    }),
    required: true,
    error: Boolean(validationMessages.password),
    validationMessage: !!validationMessages.password && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: validationMessages.password
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      autoComplete: `exchangepass-no-autocomplete-${Math.random()}`,
      type: "password",
      name: "password",
      disabled: isPasswordFieldDisabled,
      placeholder: text(`${LANG_ROUTE}.passwordPlaceholder`),
      onChange: evt => {
        onFieldChange(evt, 'password');
      },
      value: value.password
    })
  })]
});
ExchangeAccountSettings.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  isEmailFieldDisabled: PropTypes.bool.isRequired,
  isUsernameFieldDisabled: PropTypes.bool.isRequired,
  isUsernameFieldHidden: PropTypes.bool.isRequired,
  isPasswordFieldDisabled: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ExchangeAccountSettings.defaultProps = {
  isEmailFieldDisabled: false,
  isUsernameFieldDisabled: false,
  isUsernameFieldHidden: false,
  isPasswordFieldDisabled: false
};
export default ExchangeAccountSettings;